"use client";
import React__default, { useCallback, useEffect } from 'react';
import { Divider } from '@sravni/react-design-system/lib/Divider';
import { Layout } from '@sravni/react-design-system/lib/Layout';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useStyles, useBrowserThemeDetector } from '@sravni/react-utils';
import { subscribeOnLoginSuccess } from '@sravni/utils/lib/auth';
import { convertModeToModeFlags } from '../../../consts/mode.js';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import { LoginButton } from '../../LoginButton/src/LoginButton.js';
import { Logo } from '../../Logo/src/Logo.js';
import { MobileMenuBlock } from '../../MobileMenuBlock/src/MobileMenuBlock.js';
import { MobileUserBlock } from '../../MobileUserBlock/src/MobileUserBlock.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import '../../Providers/MenuVisibilityProvider/src/MenuVisibilityProvider.js';
import { useMenuVisibility } from '../../Providers/MenuVisibilityProvider/hooks/useMenuVisibility.js';
import '../../Providers/UserMenuVisibilityProvider/src/UserMenuVisibilityProvider.js';
import { useUserMenuVisibility } from '../../Providers/UserMenuVisibilityProvider/hooks/useUserMenuVisibility.js';
import { ThemeSwitcher } from '../../ThemeSwitcher/src/ThemeSwitcher.js';
import modules_48da1506 from '../styles/MobileHeaderContent.module.less.js';

const MobileHeaderContent = React__default.forwardRef((props, ref) => {
    const { className, ...restProps } = props;
    const cx = useStyles(modules_48da1506);
    const { pushAnalyticEvent } = useAnalyticEvents();
    const handleThemeSwitcherClick = useCallback((currentTheme) => {
        window.sravniDataLayer?.push({ theme: currentTheme });
        pushAnalyticEvent("themeSwitcherClick" /* EVENTS.THEME_SWITCHER_CLICK */, { eventLabel: `Тема - ${currentTheme}` });
    }, [pushAnalyticEvent]);
    const handleAuthLoginClick = React__default.useCallback(() => {
        const callback = () => window.location.reload();
        subscribeOnLoginSuccess(callback);
        pushAnalyticEvent("login" /* EVENTS.LOGIN */);
    }, [pushAnalyticEvent]);
    const handleBrowserThemeDetectorChange = React__default.useCallback((currentTheme) => {
        window.sravniDataLayer?.push({ theme: currentTheme });
        pushAnalyticEvent("themeDetectorChange" /* EVENTS.THEME_DETECTOR_CHANGE */, { eventLabel: `Тема - ${currentTheme}` });
    }, [pushAnalyticEvent]);
    const { mode, user, fixedBackground, enableTheme, search } = useCustomProps();
    const { isShowMenu, isShowLogo, isShowUser } = convertModeToModeFlags(mode);
    const [isUserMenuVisible, setIsUserMenuVisible] = useUserMenuVisibility();
    const [isMenuVisible, setIsMenuVisible] = useMenuVisibility();
    const isUserExist = !!user;
    useEffect(() => {
        if (isUserMenuVisible)
            setIsMenuVisible(false);
    }, [isUserMenuVisible, setIsMenuVisible]);
    useEffect(() => {
        if (isMenuVisible)
            setIsUserMenuVisible(false);
    }, [isMenuVisible, setIsUserMenuVisible]);
    useBrowserThemeDetector({ enabled: enableTheme, onChange: handleBrowserThemeDetectorChange });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("header", { ref: ref, "data-qa": "Header", className: cx(className, 'container', {
                containerActive: fixedBackground || isUserMenuVisible || isMenuVisible,
            }), ...restProps },
            React__default.createElement(Layout, { className: cx('layout') },
                React__default.createElement(Space, { size: 12, inline: true },
                    isShowMenu ? React__default.createElement(MobileMenuBlock, null) : null,
                    isShowLogo ? React__default.createElement(Logo, null) : null),
                React__default.createElement(Space, { size: 12, inline: true },
                    search,
                    enableTheme ? React__default.createElement(ThemeSwitcher, { onClick: handleThemeSwitcherClick }) : null,
                    isShowUser && isUserExist ? React__default.createElement(MobileUserBlock, null) : null,
                    isShowUser && !isUserExist ? React__default.createElement(LoginButton, { onClickCapture: handleAuthLoginClick }) : null))),
        React__default.createElement(Divider, null)));
});
MobileHeaderContent.displayName = 'MobileHeaderContent';

export { MobileHeaderContent };
//# sourceMappingURL=MobileHeaderContent.js.map
